export default "__VITE_PUBLIC_ASSET__b91fb44e__"